"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_STATE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
exports.INITIAL_STATE = {
    tosChecked: false
};
class RedeemModal extends React.Component {
    constructor(props) {
        super(props);
        this.checkboxClicked = () => {
            const { tosChecked } = this.state;
            this.setState({ tosChecked: !tosChecked });
        };
        this.openTos = () => {
            window.open(this.props.rewardTerms, '_blank');
        };
        this.state = Object.assign({}, exports.INITIAL_STATE);
    }
    render() {
        const { open, onClose, amount, redeemableTokens, classes, onQuantityChange, quantity, onRedeem, maxRedeemAvailable, rewardTerms, disableSlider, t } = this.props;
        const { tosChecked } = this.state;
        return ((0, jsx_runtime_1.jsx)(core_1.Dialog, Object.assign({ TransitionComponent: core_1.Grow, "aria-labelledby": "modal-title", open: open, keepMounted: true, onClose: onClose.bind(false), className: 'po-widget-dialog' }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.redeemModal }, { children: [(0, jsx_runtime_1.jsx)(core_1.DialogTitle, Object.assign({ id: "alert-dialog-slide-title", disableTypography: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h6", id: "modal-title", align: 'center', className: classes.greyColor }, { children: t('arcade.reward.enter') })) })), (0, jsx_runtime_1.jsxs)(core_1.DialogContent, { children: [(0, jsx_runtime_1.jsx)(package_1.RedeemQuantitySlider, { onQuantityChange: onQuantityChange, maxRedeemAvailable: maxRedeemAvailable, quantity: quantity, hideRedeemableQuantity: this.props.hideRedeemableQuantity, disableSlider: disableSlider, currentQuantity: null, color: 'primary' }), (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12, container: true }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ md: 6, xs: 6, item: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body2", className: classes.redeemModalTextPoints }, { children: `${this.props.t('arcade.reward.cost')} ${(amount * quantity).toPointsFormat()} ${this.props.t('arcade.reward.tokens')}` })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ md: 6, xs: 6, item: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body2", className: classes.redeemModalTextPoints }, { children: `${this.props.t('rewards.maxQuantity')}:
                  ${maxRedeemAvailable.toPointsFormat()}` })) }))] })), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body2", className: classes.redeemModalPoints }, { children: `${this.props.t('arcade.reward.total')} ${redeemableTokens.toPointsFormat()}` })), rewardTerms && ((0, jsx_runtime_1.jsx)(package_1.TosCheckbox, { tosChecked: tosChecked, handleTosChecked: this.checkboxClicked, openTos: this.openTos, text2: this.props.t('reward.tos', 'Terms of Service'), textColor: this.props.theme.palette.grey['900'], linkColor: this.props.theme.palette.secondary.dark }))] }), (0, jsx_runtime_1.jsxs)(core_1.DialogActions, Object.assign({ className: classes.redeemModalActions }, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ color: 'primary', size: 'large', variant: 'text', onClick: onClose, className: 'textButton' }, { children: t('arcade.reward.cancel') })), (0, jsx_runtime_1.jsx)(package_1.ArcadePopupButton, { title: t('arcade.reward.redeem'), onSubmit: onRedeem, isDisabled: !!rewardTerms && !tosChecked })] }))] })) })));
    }
}
const styles = (theme) => (0, core_1.createStyles)({
    redeemModal: {
        width: '28em',
        [theme.breakpoints.down('xs')]: {
            width: '18.8em'
        },
        [theme.breakpoints.down('xs')]: {
            width: '17.5em'
        }
    },
    redeemModalTextPoints: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        color: theme.palette.grey['900']
    },
    redeemModalPoints: {
        marginBottom: theme.spacing(),
        color: theme.palette.grey['900']
    },
    redeemModalActions: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(2),
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    greyColor: {
        color: theme.palette.grey['900']
    }
});
exports.default = (0, core_1.withStyles)(styles)((0, styles_1.withTheme)((0, react_i18next_1.withTranslation)()(RedeemModal)));
//# sourceMappingURL=RedeemModal.js.map